import axios from '../config/axios';
import * as actionTypes from '../config/actionTypes';
// import * as constants from '../config/constants';


export const showSites = (sites) => {
  return {
    type: actionTypes.SHOW_SITES,
    payload: sites,
  };
};


export const getSitesError = (error) => {
  return {
    type: actionTypes.GET_SITES_ERROR,
    payload: error,
  };
};


export const selectingSite = () => {
  return {
    type: actionTypes.SELECTING_SITE,
  };
};


export const siteSelected = (site) => {
  return {
    type: actionTypes.SITE_SELECTED,
    payload: site,
  };
};


export const siteSelectedFromLocal = (siteJSON) => {
  return {
    type: actionTypes.SITE_SELECTED,
    payload: JSON.parse(siteJSON),
  };
};


export const redirectToSite = (site) => {
  return () => {
    const siteUrl = `https://${site.domain}`;
    window.location = siteUrl;
  };
};


export const selectSite = (site) => {
  return (dispatch) => {
    dispatch(selectingSite());
    if (site.domain === window.location.host) {
      localStorage.setItem('site', JSON.stringify(site));
      dispatch(siteSelected(site));
    } else {
      dispatch(redirectToSite(site));
    }
  };
};


export const selectSiteFromHost = (sites) => {
  return (dispatch) => {
    const site = sites.filter((val) => {
      return val.domain === window.location.host;
    });
    dispatch(selectSite(site[0]));
  };
};


export const getSites = () => {
  return (dispatch) => {
    axios.get('common/get-sites')
      .then((response) => {
        // if (window.location.host !== constants.MAIN_SITE_HOST && !dropdown) {
        //   dispatch(selectSiteFromHost(response.data));
        // } else if (window.location.search.startsWith('?redirected_from=') && !dropdown) {
        //   dispatch(selectSiteFromHost(response.data));
        // } else {
        //   dispatch(showSites(response.data));
        // }
        dispatch(selectSiteFromHost(response.data));
      })
      .catch((error) => {
        dispatch(getSitesError(error.message));
      });
  };
};



// WEBPACK FOOTER //
// ./src/common/actions.js